import { render, staticRenderFns } from "./page.vue?vue&type=template&id=7a21c825"
import script from "./page.vue?vue&type=script&lang=js"
export * from "./page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a21c825')) {
      api.createRecord('7a21c825', component.options)
    } else {
      api.reload('7a21c825', component.options)
    }
    module.hot.accept("./page.vue?vue&type=template&id=7a21c825", function () {
      api.rerender('7a21c825', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/permission/page.vue"
export default component.exports